import { useEffect, useState } from "react";
import { Col, Image, Row, Container } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api, url } from "../axios/api";
import moment from 'moment';
import 'moment/locale/pt'; // Importar português para datas mais elegantes
import { Link } from "react-router-dom";
import { logo } from "../static";

const Noticias = () => {
    const [noticias, setNoticias] = useState([]);

    const getNoticias = async () => {
        try {
            const res = await api.get(`/Noticia.php?action=listAll`);
            setNoticias(res.data.data || []);
        } catch (error) {
            console.error("Erro ao carregar notícias:", error);
        }
    }

    useEffect(() => {
        getNoticias();
        moment.locale('pt');
    }, []);

    return (
        <>
            <Navbar />

            <main style={{ backgroundColor: "#fdfcf9" }}>
                {/* --- HEADER DA PÁGINA --- */}
                <section 
                    className="py-5 position-relative overflow-hidden" 
                    style={{ backgroundColor: "#2c2219", color: "#f4f1ea", minHeight: "30vh", display: "flex", alignItems: "center" }}
                >
                    <div 
                        className="position-absolute w-100 h-100"
                        style={{
                            top: 0, left: 0,
                            backgroundImage: `url(${logo})`,
                            backgroundSize: '40px 40px',
                            backgroundRepeat: 'repeat',
                            opacity: 0.03,
                            zIndex: 1
                        }}
                    />
                    <Container className="position-relative" style={{ zIndex: 2 }}>
                        <h6 className="text-uppercase fw-bold mb-2" style={{ color: "#c5a47e", letterSpacing: "3px" }}>Informativo Jurídico</h6>
                        <h1 className="display-4 fw-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Notícias & Artigos</h1>
                    </Container>
                </section>

                {/* --- LISTAGEM DE NOTÍCIAS --- */}
                <Container className="py-5 my-4">
                    <Row className="g-4">
                        {noticias.length > 0 ? (
                            noticias.map((item, index) => (
                                <Col lg={4} md={6} key={item.id || index}>
                                    <Link 
                                        to={`/noticias/detalhes/${item.id}/`} 
                                        className="text-decoration-none group-hover"
                                        style={{ color: "inherit" }}
                                    >
                                        <div className="overflow-hidden mb-3 border" style={{ height: "16em" }}>
                                            <Image 
                                                src={url + "/uploads/" + item.foto} 
                                                className="w-100 h-100 object-fit-cover transition-transform"
                                                style={{ transition: 'transform 0.5s ease' }}
                                            />
                                        </div>
                                        
                                        <div className="px-1">
                                            <div className="d-flex align-items-center mb-2">
                                                <span style={{ height: "1px", width: "30px", backgroundColor: "#c5a47e", display: "inline-block", marginRight: "10px" }}></span>
                                                <small className="text-uppercase fw-bold" style={{ color: "#c5a47e", fontSize: "0.7rem", letterSpacing: "1px" }}>
                                                    {moment(item.createdAt).format("DD [DE] MMMM, YYYY")}
                                                </small>
                                            </div>

                                            <h5 className="fw-bold mb-3 article-title" style={{ color: "#2c2219", fontFamily: "'Playfair Display', serif", lineHeight: "1.4" }}>
                                                {item.titulo}
                                            </h5>
                                            
                                            <span className="text-uppercase small fw-bold" style={{ fontSize: "0.75rem", borderBottom: "1px solid #c5a47e", paddingBottom: "2px" }}>
                                                Ler Artigo Completo →
                                            </span>
                                        </div>
                                    </Link>
                                </Col>
                            ))
                        ) : (
                            <Col className="text-center py-5">
                                <p className="text-muted">Nenhuma publicação encontrada no momento.</p>
                            </Col>
                        )}
                    </Row>
                </Container>
            </main>

            <Footer />

            <style>{`
                .transition-transform:hover {
                    transform: scale(1.05);
                }
                .article-title {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    min-height: 2.8em;
                    transition: color 0.3s ease;
                }
                .group-hover:hover .article-title {
                    color: #c5a47e !important;
                }
                .group-hover:hover .transition-transform {
                    transform: scale(1.1);
                }
            `}</style>
        </>
    );
};

export default Noticias;